import React from "react";
import { Loader2, SearchX, AlertTriangle } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

export const OsmAttribution = ({ className = "" }) => {
  const { t } = useLang();
  return (
    <p className={`text-xs text-white/45 ${className}`} data-testid="osm-attribution">
      {t("directory.data_from")}{" "}
      <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer"
        className="text-gold/80 hover:text-gold underline underline-offset-2" data-testid="osm-attribution-link">
        © OpenStreetMap contributors
      </a>{" "}
      · ODbL
    </p>
  );
};

export const LoadingGrid = () => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="directory-loading">
    {Array.from({ length: 6 }).map((_, i) => (
      <div key={i} className="h-36 rounded-2xl bg-surface/60 border border-white/[0.06] animate-pulse" />
    ))}
  </div>
);

export const StateBox = ({ kind, title, body, onRetry, actionLabel }) => {
  const { t } = useLang();
  const Icon = kind === "error" ? AlertTriangle : kind === "loading" ? Loader2 : SearchX;
  return (
    <div className="rounded-2xl border border-white/[0.06] bg-surface/40 p-10 text-center" data-testid={`directory-${kind}-state`}>
      <Icon className={`mx-auto text-gold/70 ${kind === "loading" ? "animate-spin" : ""}`} size={28} />
      <div className="font-display text-xl text-white mt-3">{title}</div>
      {body && <p className="text-white/55 text-sm mt-1 max-w-md mx-auto">{body}</p>}
      {onRetry && (
        <button onClick={onRetry} data-testid="directory-retry-btn"
          className="mt-5 px-5 py-2 rounded-full border border-white/15 text-white text-sm hover:border-gold/40 transition-colors duration-200">
          {actionLabel || t("directory.retry")}
        </button>
      )}
    </div>
  );
};
